import React from 'react';
import { Grid, FormControl, Select, MenuItem, Button, CircularProgress, Box, Typography } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { t } from '../../../utils/textUtils';

const UnitSelector = ({
  bangunanList,
  selectedProject,
  selectedBangunan,
  loading,
  isProjectMode,
  onUnitChange,
  onSelectUnit
}) => {
  const isDisabled = !selectedProject || isProjectMode;
  const isActive = !!selectedBangunan && !isProjectMode;

  return (
    <>
      <Grid size={{ xs: 12, md: 3 }}>
        <Box>
          <Typography variant="caption" sx={{ fontWeight: 600, color: isDisabled ? '#CBD5E1' : '#475569', mb: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ width: 20, height: 20, borderRadius: '50%', bgcolor: isDisabled ? '#CBD5E1' : '#0f172a', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', fontWeight: 700, flexShrink: 0 }}>2</Box>
            {t('Pilih Unit Bangunan')}
          </Typography>
          <FormControl fullWidth disabled={isDisabled}>
            <Select
              value={selectedBangunan}
              onChange={(e) => onUnitChange(e.target.value)}
              displayEmpty
              startAdornment={<ApartmentIcon sx={{ color: isDisabled ? '#CBD5E1' : '#94A3B8', mr: 1, fontSize: 18 }} />}
              renderValue={(selected) => {
                const bangunan = bangunanList.find(m => m.id === selected);
                return bangunan
                  ? <Typography variant="body2" sx={{ fontWeight: 600, color: '#0f172a' }}>{bangunan.name}</Typography>
                  : <Typography variant="body2" sx={{ color: isDisabled ? '#CBD5E1' : '#94A3B8' }}>{t('PILIH UNIT BANGUNAN')}</Typography>;
              }}
              sx={{
                borderRadius: 2,
                bgcolor: isDisabled ? '#F8FAFC' : '#F8FAFC',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: isDisabled ? '#E2E8F0' : '#E2E8F0' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: isDisabled ? '#E2E8F0' : '#94A3B8' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0f172a' }
              }}
            >
              <MenuItem value=""><em>{t('PILIH UNIT BANGUNAN')}</em></MenuItem>
              {bangunanList.map((bangunan) => (
                <MenuItem key={bangunan.id} value={bangunan.id}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{bangunan.name}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>

      <Grid size={{ xs: 12, md: 1.5 }}>
        <Box>
          <Typography variant="caption" sx={{ opacity: 0, display: 'block', mb: 0.5 }}>.</Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={onSelectUnit}
            disabled={!selectedProject || !selectedBangunan || loading || isProjectMode}
            sx={{
              height: '40px',
              bgcolor: isActive ? '#22C55E' : '#334155',
              color: '#fff',
              borderRadius: 2,
              fontWeight: 700,
              fontSize: '0.8rem',
              boxShadow: isActive ? '0 4px 12px rgba(34,197,94,0.3)' : '0 4px 12px rgba(51,65,85,0.2)',
              '&:hover': { bgcolor: isActive ? '#16A34A' : '#475569' },
              '&.Mui-disabled': { bgcolor: '#E2E8F0', color: '#94A3B8' }
            }}
          >
            {loading ? <CircularProgress size={18} color="inherit" /> : isActive ? '✓ ' + t('DIPILIH') : t('PILIH')}
          </Button>
        </Box>
      </Grid>
    </>
  );
};

export default UnitSelector;
